'use client';

import { SvgIcon, SvgIconProps } from '../components';

export const Coinmarketcap = (props: SvgIconProps) => (
  <SvgIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="16" height="16" rx="8" fill="#3C69F7" />
    <path
      d="M11.4508 8.91364C11.2856 9.01327 11.0929 9.03092 10.9456 8.94958C10.7619 8.84113 10.6517 8.59711 10.6517 8.26229V7.24017C10.6517 6.7515 10.459 6.39902 10.128 6.30886C9.56784 6.14618 9.14528 6.82464 8.98907 7.07749L7.99735 8.64187V6.71556C7.98838 6.27229 7.84113 6.00998 7.56583 5.92864C7.38208 5.87441 7.10678 5.90152 6.84045 6.2994L4.62716 9.7901C4.33329 9.23837 4.17708 8.62359 4.17708 7.99935C4.17708 5.89207 5.89418 4.18266 7.99735 4.18266C10.1005 4.18266 11.8176 5.89207 11.8176 7.99935V8.01763C11.8362 8.42434 11.7075 8.75033 11.4501 8.91301L11.4508 8.91364ZM12.6627 7.99998V7.98169C12.6538 5.42231 10.5596 3.33331 7.99799 3.33331C5.43642 3.33331 3.33325 5.42231 3.33325 7.99998C3.33325 10.5776 5.42681 12.6666 7.99799 12.6666C9.18242 12.6666 10.3028 12.2234 11.1659 11.4188C11.3406 11.2561 11.3496 10.9938 11.1844 10.8217C11.0282 10.6495 10.7619 10.6407 10.5877 10.7946L10.5788 10.8034C9.88091 11.4547 8.94425 11.8255 7.98006 11.8255C6.85069 11.8255 5.8404 11.3368 5.14255 10.5594L7.13495 7.41231V8.86824C7.13495 9.56436 7.41025 9.79073 7.6401 9.85378C7.86994 9.91684 8.21887 9.87207 8.59532 9.28377L9.6882 7.53842C9.72469 7.48419 9.75222 7.42997 9.78936 7.39403V8.28057C9.78936 8.93193 10.0557 9.45654 10.5147 9.70939C10.9277 9.94458 11.4514 9.91747 11.8829 9.65516C12.4156 9.31151 12.7005 8.71439 12.6634 7.99998H12.6627Z"
      fill="white"
    />
  </SvgIcon>
);
